import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

// The per-field resolved view of an invoice: the value the document would
// render today for every template variable. `values` is the system resolution
// WITHOUT operator overrides layered in; `overrides` is the active override
// set — the effective display value is `overrides[key] ?? values[key]`, and a
// "reset to system value" affordance re-shows `values[key]` directly.
export type ResolvedFieldValue = string | number | null;

export interface InvoiceRenderContext {
  readonly invoice_id: string;
  readonly values: Readonly<Record<string, ResolvedFieldValue>>;
  readonly adjustment_lines: readonly Readonly<Record<string, ResolvedFieldValue>>[];
  readonly overrides: Readonly<Record<string, ResolvedFieldValue>>;
}

export function invoiceRenderContextKey(invoiceId: string | null) {
  return ['invoice-render-context', invoiceId] as const;
}

export function useInvoiceRenderContext(invoiceId: string | null) {
  return useQuery<InvoiceRenderContext>({
    queryKey: invoiceRenderContextKey(invoiceId),
    enabled: invoiceId !== null,
    queryFn: () =>
      apiRequest<InvoiceRenderContext>(
        `/invoices/${encodeURIComponent(invoiceId ?? '')}/render-context`,
      ),
  });
}
